import CurrentHourEntries from "./CurrentHourEntries";

export default CurrentHourEntries;